import axios from "axios";
import * as jwtService from "./jwt.service";

const baseURL = process.env.REACT_APP_API_ENDPOINT;

const instance = axios.create({
  baseURL,
});

instance.interceptors.request.use((config) => {
  const jwt = jwtService.get();
  if (jwt?.access_token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${jwt.access_token}`;
    config.headers.Accept = config.headers.Accept || "application/json";
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== "/login") {
      return jwtService.remove(() => {
        window.location.replace("/login");
      });
    }

    return Promise.reject(error);
  }
);

export default instance;
